module.exports = __webpack_public_path__ + "img/快乐绿色.1628ad35.png";